import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader,
  MenuItem,  
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableFooter
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik, validateYupSchema } from 'formik';
import * as Yup from "yup";
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import { useAlert } from "react-alert";
import xlsx from 'json-as-xlsx';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import { LoadingComponent } from './../../../../utils/newLoader';
import { DatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },
  tableContainer: {
    marginTop: theme.spacing(2),
},
table: {
    border: '1px solid #ccc',
},
tableHead: {
    backgroundColor: theme.palette.background.default,
    borderBottom: '1px solid #ccc',
    borderTop: '1px solid #ccc',
},
tableCell: {
    borderBottom: 'none',
},
tableHeaderCell: {
    fontWeight: 'bold',
},
tableCellRight: {
    textAlign: 'right',
    paddingRight: '40px',
    borderBottom: 'none',
},
tableCellLeft: {
    textAlign: 'left',
    borderBottom: 'none',
},
tableHeaderCellRight: {
    textAlign: 'right',
    fontWeight: 'bold',
},
tableHeaderCellLeft: {
    textAlign: 'left',
    fontWeight: 'bold',
},
tableHeaderCellBorderLeft: {
    textAlign: 'left',
    fontWeight: 'bold',
    borderLeft: '1px solid #ccc',
},
tableHeaderCellBorderRight: {
    textAlign: 'right',
    fontWeight: 'bold',
    
},
}));
const screenCode = 'NOTSUPPLYDEBTLISTREPORT';

export default function NotSupplyDebtListReport(props) {
  const [title, setTitle] = useState("Not Supply Debt List Report");
  const classes = useStyles();
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [routeList, setRouteList] = useState();
  const [selectedDate, setSelectedDate] = useState(new Date());
  
  const [notSupplyDebtDetail, setNotSupplyDebtDetail] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    month: moment(new Date()).format('MM'),
    year: moment(new Date()).format('YYYY')
  });
  
  const [notSupplyDebtList, setNotSupplyDebtList] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "0",
    factoryName: "0",
    routeName:"0",
    monthName: moment(new Date()).format('MMM').toUpperCase()
  });
  const [csvHeaders, SetCsvHeaders] = useState([]);
  const navigate = useNavigate();
  const alert = useAlert();
  const componentRef = useRef();
  const options = {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);


  useEffect(() => {
    trackPromise(
      getPermission());
    trackPromise(
      getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(
      getFactoriesForDropdown());
  }, [notSupplyDebtDetail.groupID]);

  useEffect(() => {
    trackPromise(
      getRoutesByFactoryID());
  }, [notSupplyDebtDetail.factoryID]);

   useEffect(() => {
      if (notSupplyDebtDetail.factoryID > 0 && notSupplyDebtDetail.groupID > 0) {
        trackPromise(GetBalancePaymentYearMonthForDropDown());
      }
    }, [notSupplyDebtDetail.factoryID, notSupplyDebtDetail.groupID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWNOTSUPPLYDEBTLISTREPORT');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setNotSupplyDebtDetail({
      ...notSupplyDebtDetail,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(notSupplyDebtDetail.groupID);
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routes = await services.getRoutesForDropDown(notSupplyDebtDetail.factoryID);
    setRouteList(routes);
  }

  async function GetNotSupplyDebtList() {
    const applicableYear = selectedDate.getFullYear().toString();
    const applicableMonth = (selectedDate.getMonth() + 1).toString();
    let model = {
      groupID: parseInt(notSupplyDebtDetail.groupID),
      factoryID: parseInt(notSupplyDebtDetail.factoryID),
      routeID: parseInt(notSupplyDebtDetail.routeID),
      applicableMonth,
      applicableYear
    }
    const response = await services.GetNotSupplyDebtList(model);

    getSelectedDropdownValuesForReport(model);

    if (response.statusCode == "Success" && response.data != null) {
      setNotSupplyDebtList(response.data);
      createDataForExcel(response.data);

      if (response.data.length == 0) {
        alert.error("No records to display");
      }
    }
    else {
      alert.error(response.message);

    }
  }
 async function GetBalancePaymentYearMonthForDropDown() {
    var response = await services.GetBalancePaymentYearMonth(notSupplyDebtDetail.groupID, notSupplyDebtDetail.factoryID);

    const applicableYear = parseInt(response.applicableYear);
    const applicableMonth = parseInt(response.applicableMonth) - 1;

    const selectedDate = new Date(applicableYear, applicableMonth);

    setSelectedDate(selectedDate);
  
  };
  async function createDataForExcel(array) {
    
    var res = [];
    
    if (array != null) {
      array.map(x => {
        var vr = {
          'Route Name': x.routeName,
          'Registration Number': x.registrationNumber,
          'Customer Name': x.name,
          'Last 3 Months Crop Avg (Kg)': x.lastThreeMonthAvg,
          'Todate Crop (Kg)': x.todateCrop,
          'Debt Amount (Rs)': x.amount,
          'Loan Balance (Rs)': x.loanBalance,
          'Last Supply Month': x.lastSupplyMonth
        }
        res.push(vr);
      });
    }
    res.push('');
    var vr = {
        'Route Name':`Group : ${selectedSearchValues.groupName}` ,
        'Registration Number': `Factory :${selectedSearchValues.factoryName}`,
    }
    res.push(vr);
   
    var vr = {
      'Route Name':`Route: ${selectedSearchValues.routeName}` ,
      'Registration Number': `Month & Year: ${selectedSearchValues.monthName || notSupplyDebtDetail.month} / ${notSupplyDebtDetail.year}`,
  }
    res.push(vr);

    return res;
  }

  async function createFile() {

    var file = await createDataForExcel(notSupplyDebtList);
    var settings = {
      sheetName: 'Not Supply Debt List Report',
      fileName: 'Not Supply Debt List Report - ' + selectedSearchValues.groupName + ' - ' + selectedSearchValues.factoryName,
      writeOptions: {}
    }

    let keys = Object.keys(file[0])
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })

    let dataA = [
      {
        sheet: 'Not Supply Debt List Report',
        columns: tempcsvHeaders,
        content: file
      }
    ]

    xlsx(dataA, settings);
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setNotSupplyDebtDetail({
      ...notSupplyDebtDetail,
      [e.target.name]: value
    });
    setNotSupplyDebtList([]);
  }

  function getSelectedDropdownValuesForReport(searchForm) {

    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[searchForm.groupID],
      factoryName: FactoryList[searchForm.factoryID],
      routeName: routeList[searchForm.routeID] || "All"

    })
  }
function handleDateChange(date) {
    let monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    var month = date.getUTCMonth() + 1; 
    var year = date.getUTCFullYear();
    var currentmonth = moment().format('MM');
    let monthName = monthNames[month - 1];
    setSelectedSearchValues({
      ...selectedSearchValues,
      monthName: monthName
    });
    setNotSupplyDebtDetail({
      ...notSupplyDebtDetail,
      month: month.toString(),
      year: year.toString()
    });

    if (selectedDate != null) {

      var prevMonth = selectedDate.getUTCMonth() + 1
      var prevyear = selectedDate.getUTCFullYear();

      if ((prevyear == year && prevMonth != month) || (prevyear != year)) {
        setSelectedDate(date)
      }
    } else {
      setSelectedDate(date)
    }
    setNotSupplyDebtList([]);
  }
  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }
  const getPageMargins = () => {
    return `@media print {
            @page {
            size: A4 Landscape !important;
            background-color: white !important;
        }
        body {
            transform-origin: top left;
            background-color: white !important;
        }
    }`;
};


const handleChangePage = (event, newPage) => {
  setPage(newPage);
};

const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(0);
};
  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: notSupplyDebtDetail.groupID,
              factoryID: notSupplyDebtDetail.factoryID,
              month: notSupplyDebtDetail.month,
              year: notSupplyDebtDetail.year
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                month: Yup.string().required('Month is required'),
                year: Yup.string().required('Year is required')
              })
            }
            onSubmit={() => trackPromise(GetNotSupplyDebtList())}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched,
              values,
              setFieldValue
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleChange(e);
                                setFieldValue("groupID", e.target.value);
                              }}
                              value={notSupplyDebtDetail.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleChange(e);
                                setFieldValue("factoryID", e.target.value);
                              }}
                              value={notSupplyDebtDetail.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="routeID">
                              Route
                            </InputLabel>
                            <TextField select
                              fullWidth
                              name="routeID"
                              onChange={(e) => handleChange(e)}
                              value={notSupplyDebtDetail.routeID}
                              variant="outlined"
                              id="routeID"
                              size='small'
                            >
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routeList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DatePicker
                              autoOk
                              variant="inline"
                              openTo="month"
                              views={["year", "month"]}
                              label="Year and Month"
                              helperText={touched.month && errors.month ? errors.month : "Select applicable month"}
                              value={selectedDate}
                              size='small'
                              onChange={(date) => {
                                handleDateChange(date);
                                setFieldValue("month", moment(date).format('MM'));
                                setFieldValue("year", moment(date).format('YYYY'));
                              }}
                              required
                              error={Boolean(touched.month && errors.month) || Boolean(touched.year && errors.year)}
                            />
                          </MuiPickersUtilsProvider>
                        </Grid>
                        </Grid>
                        <Box display="flex" flexDirection="row-reverse" p={2} >
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                            size='small'
                          >
                            Search
                          </Button>
                        </Box>
                      </CardContent>
                      <Box minWidth={1050}>
                      {notSupplyDebtList.length > 0 && (
                      <TableContainer component={Paper} className={classes.tableContainer}>
                      <Table className={classes.table} size="small" stickyHeader>
                      <TableHead className={classes.tableHead}>
                      <TableRow>
                      <TableCell className={classes.tableHeaderCellBorderLeft}style={{width:'12%'}}>Route Name</TableCell>
                      <TableCell className={classes.tableHeaderCellLeft}>Registration Number</TableCell>
                      <TableCell className={classes.tableHeaderCellLeft}style={{width:'18%'}}>Customer Name</TableCell>
                      <TableCell className={classes.tableHeaderCellRight}>Last 3 Months Crop Avg (KG)</TableCell>
                      <TableCell className={classes.tableHeaderCellRight}>Todate Crop (KG)</TableCell>
                      <TableCell className={classes.tableHeaderCellRight}>Debt Amount (RS.)</TableCell>
                      <TableCell className={classes.tableHeaderCellBorderRight}>Loan Balance (Rs.)</TableCell>
                      <TableCell className={classes.tableHeaderCellRight}>Last Supply Month</TableCell>
                      </TableRow>
                      </TableHead>
                     <TableBody>
                     {notSupplyDebtList
                     .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                     .map((row, index) => (
                     <TableRow key={index}>
                     <TableCell className={classes.tableCellLeft}style={{width:'12%'}}>{row.routeName}</TableCell>
                     <TableCell className={classes.tableCellLeft}>{row.registrationNumber}</TableCell>
                     <TableCell className={classes.tableCellLeft}style={{width:'18%'}}>{row.name}</TableCell>
                     <TableCell className={classes.tableCellRight}>
                       {Number(row.lastThreeMonthAvg).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                     </TableCell>
                    <TableCell className={classes.tableCellRight}>
                       {Number(row.todateCrop).toLocaleString()}
                    </TableCell>
                    <TableCell className={classes.tableCellRight}>
                       {Number(row.amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                    <TableCell className={classes.tableCellRight}>
                        {Number(row.loanBalance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                    <TableCell className={classes.tableCellRight}>{row.lastSupplyMonth}</TableCell>
                    </TableRow>
                      ))}
                    </TableBody>
                    <TableFooter style={{ position: "sticky", bottom: 0 }}>
                    <TableRow style={{ borderTop: '1px solid #ccc' }}>
                    <TableCell colSpan={3} className={classes.tableCellLeft} style={{ fontWeight: "bolder", fontSize:'14px', color:"black", borderTop:'1px solid #ccc' }}>
                      Total
                    </TableCell>
                    <TableCell className={classes.tableCellRight} style={{ fontWeight: "bolder", fontSize:'14px', color:"black", borderTop:'1px solid #ccc' }}>
                       {notSupplyDebtList.reduce((sum, row) => sum + Number(row.lastThreeMonthAvg), 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                    <TableCell className={classes.tableCellRight} style={{ fontWeight: "bolder", fontSize:'14px', color:"black", borderTop:'1px solid #ccc' }}>
                       {notSupplyDebtList.reduce((sum, row) => sum + Number(row.todateCrop), 0).toLocaleString()}
                    </TableCell>
                    <TableCell className={classes.tableCellRight} style={{ fontWeight: "bolder", fontSize:'14px', color:"black", borderTop:'1px solid #ccc' }}>
                       {notSupplyDebtList.reduce((sum, row) => sum + Number(row.amount), 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                    <TableCell className={classes.tableCellRight} style={{ fontWeight: "bolder", fontSize:'14px', color:"black", borderTop:'1px solid #ccc' }}>
                       {notSupplyDebtList.reduce((sum, row) => sum + Number(row.loanBalance), 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                    <TableCell className={classes.tableCellRight} style={{ fontWeight: "bolder", fontSize:'14px', color:"black", borderTop:'1px solid #ccc' }}> 
                    </TableCell>
                 </TableRow>
               </TableFooter>
             </Table>
            <TablePagination
             rowsPerPageOptions={[10, 20, 30]}
             component="div"
             count={notSupplyDebtList.length}
             rowsPerPage={rowsPerPage}
             page={page}
             onPageChange={handleChangePage}
             onChangeRowsPerPage={handleChangeRowsPerPage}
            />
           </TableContainer>
            )}
          </Box>
                       {notSupplyDebtList.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={() => createFile()}
                            size='small'
                          >
                            EXCEL
                          </Button>
                          <ReactToPrint
                            documentTitle={"Not Supply Debt List Report"}
                            trigger={() => <Button
                              color="primary"
                              id="btnRecord"
                              type="submit"
                              variant="contained"
                              style={{ marginRight: '1rem' }}
                              className={classes.colorCancel}
                              size='small'
                            >
                              PDF
                          </Button>}
                            content={() => componentRef.current}
                            pageStyle={getPageMargins()}
                          />
                          <div hidden={true}>
                            <CreatePDF ref={componentRef}
                              notSupplyDebtList={notSupplyDebtList}
                              searchData={{
                                ...selectedSearchValues,
                                month: notSupplyDebtDetail.month,
                                year: notSupplyDebtDetail.year
                              }}
                            />
                          </div>
                        </Box> : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}